/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import Filters from '../../../../table/new/filters/Filters';
import Presets from '../../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../../table/new/TableWrapper';
import Columns from '../../../../table/new/Columns';
import {baseFields} from '../../../../table/new/customizationTable';
import BlankSheet from '../../../../table/new/BlankSheet';
import FullScreen from '../../../../table/new/FullScreen';
import Refresh from '../../../../table/new/Refresh';
import ResultsCount from '../../../../table/new/ResultsCount';
import Search from '../../../../table/new/SearchForTable';

const Statistics = () => {
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  return (
    <PageWrapper
      firstTimeConfig='7day'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Трекер'},
        {isSeparator: true},
        {title: 'Influence'},
        {isSeparator: true},
        {title: 'Статистика Influence', path: '/tracker/influence/statistics', isActive: true},
      ]}
      title={'Статистика Influence'}
    >
      <TableWrapper
        branch={'inf'}
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Dashboard/Influence/Statistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
        ]}
        defaultGroups={
          [
            // {group: 'bayer', isFixed: false},
            // {group: 'pixel', isFixed: false},
          ]
        }
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields.filter((item) => item.value !== 'clicks')}
        disabledByDefault={[
          'click2reg',
          'click2cpa',
          'lead2fd',
          'lead2cpa',
          'chat2reg',
          'reg2cpa',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenHead={null}
          childrenNearGroups={
            <>
              <Search />
            </>
          }
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
          childrenByFilters={<Refresh />}
          linksForOnGroup={[
            {link: '', title: 'Общая'},
            {link: 'day', title: 'День'},
            {link: 'month', title: 'Месяц'},
            {link: 'advertiser', title: 'Рекламодатель'},
            {link: 'offer', title: 'Оффер'},
            {link: 'app', title: 'Приложения'},
            {link: 'inf_traffic', title: 'Блогер'},
            {link: 'inf_bayer', title: 'Байер'},
            {link: 'inf_source', title: 'Поток'},
          ]}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Statistics);
